import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useOrderService from '@/services/OrderService';

type Props = SetupProps<typeof DashboardOrdersMainCardSetupService.props>

export default class DashboardOrdersMainCardSetupService extends BaseSetupService<Props> {
	static readonly props = {
		color: {
			type: String as PropType<Orion.Color>,
			default: undefined,
		},
	};

	private readonly state = reactive({
		loaded: false,
		urgentCount: 0,
		newCount: 0,
		filledCount: 0,
	});

	get loaded () { return this.state.loaded; }
	get urgentCount () { return this.state.urgentCount; }
	get newCount () { return this.state.newCount; }
	get filledCount () { return this.state.filledCount; }

	constructor (props?: Props) {
		super(props);
	}

	protected async onBeforeMountAsync () {
		await this.getOrdersCountAsync();
	}

	goToOrder () {
		this.router.push({ name: 'OrderDashBoard' });
	}

	async getOrdersCountAsync () {
		const data = await useOrderService().overviewCountAsync();
		this.state.filledCount = data?.filled ?? 0;
		this.state.urgentCount = data?.urgent ?? 0;
		this.state.newCount = data?.new ?? 0;
		this.state.loaded = true;
	}
}
